import { Location } from '@angular/common';
import { Component, ElementRef, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Auth, Configuration, HttpClientCustom } from '../../shared';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';

@Component({
    selector: 'EditNotification',
    templateUrl: 'editNotificationComponent.html'
})
export class EditNotificationComponent {

    public notification: any = {};
    public notificationId: number;
    public eventId: number;
    public variables: any[] = [];
    public _baseUrl: string;
    public hideNotificationFlag: boolean = false;

    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public _http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public _location: Location,
        public vcr: ViewContainerRef,
        public translate: TranslateService) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);

        let data: any = this.share.getData();
        if (data && data.notificationId && data.eventId) {
            this.notificationId = data.notificationId;
            this.eventId = data.eventId;
            this.loadEventVariableByEventId();
            this.fetchNotification();
        }
    }

    public fetchNotification() {
        let url = this._baseUrl + 'v1/webAdmin/notification/' + this.notificationId;
        let self = this;
        self._http.get(url).subscribe((result) => {
            self.notification = result;
        }, (error) => {
            this._toaster.showError('Not able to fetch notification');
        });
    }

    public loadEventVariableByEventId() {
        let url = this._baseUrl + 'v1/webAdmin/notification/loadVariables/' + this.eventId;
        let self = this;
        self._http.get(url).subscribe((result) => {
            self.variables = result;
        }, (error) => {
            this._toaster.showError('Not able to fetch notification');
        });
    }

    public validate(): boolean {
        if (!this.notification.name || !this.notification.name.trim()) {
            this._toaster.showError('Name should not be empty');
            return false;
        }
        if (this.notification.notificationChannel === 'Email') {
            if (!this.notification.messageTemplate
                || !this.notification.messageTemplate.trim()) {
                this._toaster.showError('Message template should not be empty');
                return false;
            }

            if (!this.notification.subjectTemplate || !this.notification.subjectTemplate.trim()) {
                this._toaster.showError('Subject template should not be empty');
                return false;
            }
        }

        return true;
    }

    public save() {
        if (this.validate()) {
            let url = this._baseUrl + 'v1/webAdmin/notification';
            let self = this;
            self._http.post(url, self.notification).subscribe((result) => {
                this._toaster.showSuccess('Notification updated');
                setTimeout(function() {
                    self.cancel();
                }, 500);
            }, (error) => {
                this._toaster.showError('Somthing went wrog Notification update failed');
                console.log(error);
            });
        }
    }

    public addNewRecipient() {
        this.notification.notificationRecipients.push({recipientType: 'VARIABLE'});
    }

    public hideNotification(event) {
        this.hideNotificationFlag = event;
    }

    public cancel() {
        this.router.navigate(['menu/notifications']);
    }
}



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/editNotificationComponent.ts